const styles = theme => ({
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    borderBottom: '1px solid rgba(12,31,44,0.12)'
  },
  primaryContactContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  contactInfoContainer: {
    marginLeft: theme.spacing.unit * 2.5,
    width: '14vw'
  },
  primaryContact: {
    borderRadius: '18px',
    backgroundColor: 'rgba(0,161,251,0.08)',
    padding: '8px 16px',
    color: '#00A1FB !important'
  },
  iconRoot: {
    color: 'rgba(12,31,44,0.38)'
  },
  menuButton: {
    padding: 0,
    '&:hover': {
      backgroundColor: '#fff'
    }
  }
});

export default styles;
